// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { EntityActionsMenu_EntityFragment } from '../../../modules/entities/components/EntityActionsMenu/EntityActionsMenu.generated';
import { gql } from '@apollo/client';
import { EntityActionsMenu_EntityFragmentDoc } from '../../../modules/entities/components/EntityActionsMenu/EntityActionsMenu.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPage_EntityFragment = (
  { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'CLTTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'CRTTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'GRATTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'ILITTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'InsurancePersonalAccount', beneficiaryDesignationsReviewedAt?: Time | null, id: string, displayName: string, beneficiaryDesignations: { __typename?: 'BeneficiaryDesignations', primary?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null, contingent?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'PrivateFoundation', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'QPRTTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'RetirementPersonalAccount', beneficiaryDesignationsReviewedAt?: Time | null, id: string, displayName: string, beneficiaryDesignations: { __typename?: 'BeneficiaryDesignations', primary?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null, contingent?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'RevocableTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'SLATTrust', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null }, ownedByStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownershipPercentage?: Percent | null, owningIndividual?: { __typename?: 'ClientProfile', id: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | null, owningEntity?: { __typename?: 'Entity', id: string } | null }> | null, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, kind: Types.IntegrationEntityKind, name: string }> | null }
  & EntityActionsMenu_EntityFragment
);

export type EntityPageBasicsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type EntityPageBasicsQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EntityPage_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EntityPageBasics: 'EntityPageBasics' as const
  },
  Fragment: {
    EntityPage_Entity: 'EntityPage_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityPage_EntityFragmentDoc = gql`
    fragment EntityPage_Entity on Entity {
  id
  kind
  stage
  ...EntityActionsMenu_Entity
  subtype {
    id
    displayName
    dispositionScenarios {
      id
      reviewedAt
    }
    ... on RetirementPersonalAccount {
      beneficiaryDesignationsReviewedAt
      beneficiaryDesignations(hypotheticalWaterfallId: null) {
        primary {
          id
          dispositiveProvisions {
            totalCount
          }
        }
        contingent {
          id
          dispositiveProvisions {
            totalCount
          }
        }
      }
    }
    ... on InsurancePersonalAccount {
      beneficiaryDesignationsReviewedAt
      beneficiaryDesignations(hypotheticalWaterfallId: null) {
        primary {
          id
          dispositiveProvisions {
            totalCount
          }
        }
        contingent {
          id
          dispositiveProvisions {
            totalCount
          }
        }
      }
    }
  }
  ownedByStakes {
    id
    ownershipPercentage
    owningIndividual {
      id
      dispositionScenarios {
        id
        reviewedAt
      }
    }
    owningEntity {
      id
    }
  }
  integrationEntities {
    id
    kind
    name
  }
}
    ${EntityActionsMenu_EntityFragmentDoc}`;
export const EntityPageBasicsDocument = gql`
    query EntityPageBasics($entityId: ID!) {
  entities(where: {id: $entityId}) {
    edges {
      node {
        ...EntityPage_Entity
      }
    }
  }
}
    ${EntityPage_EntityFragmentDoc}`;

/**
 * __useEntityPageBasicsQuery__
 *
 * To run a query within a React component, call `useEntityPageBasicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageBasicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageBasicsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityPageBasicsQuery(baseOptions: Apollo.QueryHookOptions<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>(EntityPageBasicsDocument, withFetchPolicyContext(options));
      }
export function useEntityPageBasicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>(EntityPageBasicsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEntityPageBasicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>(EntityPageBasicsDocument, withFetchPolicyContext(options));
        }
export type EntityPageBasicsQueryHookResult = ReturnType<typeof useEntityPageBasicsQuery>;
export type EntityPageBasicsLazyQueryHookResult = ReturnType<typeof useEntityPageBasicsLazyQuery>;
export type EntityPageBasicsSuspenseQueryHookResult = ReturnType<typeof useEntityPageBasicsSuspenseQuery>;
export type EntityPageBasicsQueryResult = Apollo.QueryResult<EntityPageBasicsQuery, EntityPageBasicsQueryVariables>;